import { POST_PAY, POST_PAY_EMBEDDED, setPayEmbeddedData } from '../../../actions/app/pay/pay.action';
import { setError, setLoader, setStep } from '../../../actions/app/ui/ui.actions';
import { API_ERROR, API_SUCCESS, apiRequest } from '../../../actions/core/api/api.actions';
import { formatDataForApi } from '../fill/formatDataForApi';
import {setNotification} from "../../../actions/core/notifications/notifications.actions.js";
import {FILL} from "../../../actions/app/fill/fill.actions.js";
import { getStepBySlug } from '../../../../utils/function';

export const payMiddleware = (dispatch) => (next) => (action) => {
    next(action);

    const { payload } = action;

    switch (action.type) {
        case POST_PAY:
            next([
                apiRequest({ body: formatDataForApi(payload.body), method: 'POST', url: payload.data, entity: POST_PAY }),
                setLoader({ state: true, entity: POST_PAY }),
            ]);

            break;

        case `${POST_PAY} ${API_SUCCESS}`:
            next([setError({ state: false, entity: POST_PAY }), setLoader({ state: false, entity: POST_PAY })]);

            window.location = payload.data;
            break;

        case `${POST_PAY} ${API_ERROR}`:
            next([
                setNotification({
                    entity: FILL,
                    html: payload?.data?.response?.data?.error,
                    title: 'Attention !',
                    icon: 'error',
                    confirmButtonText: "J'ai compris",
                }),
                setError({ state: true, entity: POST_PAY }),
                setLoader({ state: false, entity: POST_PAY })
            ]);
            break;

        case POST_PAY_EMBEDDED:
            next([
                apiRequest({ body: formatDataForApi(payload.body), method: 'POST', url: payload.data, entity: POST_PAY_EMBEDDED }),
                setLoader({ state: true, entity: POST_PAY_EMBEDDED }),
            ]);
            break;

        case `${POST_PAY_EMBEDDED} ${API_SUCCESS}`:
            next([
                setPayEmbeddedData(payload.data),
                setError({ state: false, entity: POST_PAY_EMBEDDED }),
                setLoader({ state: false, entity: POST_PAY_EMBEDDED }),
                setStep({ step: getStepBySlug('paiement') }),
            ]);
            break;

        case `${POST_PAY_EMBEDDED} ${API_ERROR}`:
            next([
                setNotification({
                    entity: FILL,
                    html: payload?.data?.response?.data?.error || 'Erreur lors de l\'initialisation du paiement.',
                    title: 'Attention !',
                    icon: 'error',
                    confirmButtonText: "J'ai compris",
                }),
                setError({ state: true, entity: POST_PAY_EMBEDDED }),
                setLoader({ state: false, entity: POST_PAY_EMBEDDED }),
            ]);
            break;

        default:
            return null;
    }
};
